"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waiveImplementationFeeConfig = void 0;
exports.waiveImplementationFeeConfig = {
    hasWaiveImplementationFeeWhitelist: true,
};
